import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function ownKeys(a, b) {
  var c = Object.keys(a);

  if (Object.getOwnPropertySymbols) {
    var d = Object.getOwnPropertySymbols(a);
    b && (d = d.filter(function (b) {
      return Object.getOwnPropertyDescriptor(a, b).enumerable;
    })), c.push.apply(c, d);
  }

  return c;
}

function _objectSpread(a) {
  for (var b, c = 1; c < arguments.length; c++) {
    b = null == arguments[c] ? {} : arguments[c], c % 2 ? ownKeys(Object(b), !0).forEach(function (c) {
      _defineProperty(a, c, b[c]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(a, Object.getOwnPropertyDescriptors(b)) : ownKeys(Object(b)).forEach(function (c) {
      Object.defineProperty(a, c, Object.getOwnPropertyDescriptor(b, c));
    });
  }

  return a;
}

import sift from "sift";
import { queryBuilder } from "../utils"; // import { generateBuilderSlug } from "../utils";

export var initLots = function initLots(a) {
  var b = [],
      c = a.current || {},
      d = (c || {}).landforsale,
      e = a.filters,
      f = e.estate,
      g = e.neighbourhood,
      h = e.landSize,
      i = e.frontage,
      j = e.otherOptions,
      k = {
    estate: f,
    neighbourhood: g,
    otherOptions: j,
    // API NAME is different for lots
    landSize: _objectSpread({}, h, {
      apiName: "area"
    }),
    frontage: _objectSpread({}, i, {
      apiName: "frontage"
    })
  };
  return d && d.map(function (a) {
    return b = [].concat(_toConsumableArray(b), _toConsumableArray(a.lots)), a;
  }), {
    list: function list(a) {
      var c = a || {},
          d = c.sort,
          e = _objectWithoutProperties(c, ["sort"]);

      return d || (d = "frontage-desc"), b.length ? queryBuilder(b, _objectSpread({}, e, {
        filters: k,
        sort: d
      })) : b;
    },
    retrieve: function retrieve(a) {
      var c = b.find(sift({
        slug: a
      }));
      return c;
    }
  };
};
export default initLots;